import { ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnInit, Optional, Output, ViewChild } from '@angular/core';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppSettings } from 'src/app/app-settings';
import { GooglePlacesService } from 'src/app/services/google-places.service';
import { MapsService } from 'src/app/services/maps.service'
import { PlacesService } from 'src/app/services/places.service';
import { InfoCardComponent } from 'src/app/components/shared/info-card/info-card.component';
import { skip } from 'rxjs/operators';

@Component({
  selector: 'app-map-search',
  templateUrl: './map-search.component.html',
  styleUrls: ['./map-search.component.scss'],
})
export class MapSearchComponent implements OnInit {

  lugar: any = '';
  textLocation: string = '';
  address!: any;
  validAddress: boolean = false;
  @Input() online: boolean = false;
  @Input() activeSites: boolean = false;
  profile: any = {
    site: true
  };

  @Output() saveLocation = new EventEmitter<any>();
  @Output() saveOnline = new EventEmitter<any>();

  searchResults: any[] = [];
  @ViewChild(MatAutocompleteTrigger) autocomplete: MatAutocompleteTrigger;
  space!: any;
  urlImagePlace: string = AppSettings.MEDIA_URI + '/users/';
  placeList: any[] = [];
  urlImagesVenues: string = AppSettings.MEDIA_URI + '/spaces/';
  fromPanel: boolean = false;

  // Restricciones específicas cuando se usa desde el panel de edición de eventos
  eventIsPublished: boolean = false;
  eventHasSales: boolean = false;
  eventUsesMap: boolean = false;
  isSuperAdmin: boolean = false;
  panelRestrictionMessage: string | null = null;
  panelRestrictionBlock: boolean = false;

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data,
    private placeService: PlacesService,
    @Optional() private dialogRef: MatDialogRef<MapSearchComponent>,
    private googlePlacesService: GooglePlacesService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.googlePlacesService.openMap();
    this.googlePlacesService.mapsLocatorStorage.pipe(skip(1)).subscribe({
      next: (data) => {
        if (data) {
         
          if (this.activeSites) {
            return;
          }
          if (data.address_components) {
            const objectCity = data.address_components.find((value: any) =>
              value.types.includes('locality'),
            );

            if (!objectCity) {
              this.openInfoCard(
                'La localización debe ser más específica (selecciona una ciudad o dirección exacta).',
              );
              this.lugar = '';
              this.address = null;
              this.validAddress = false;
              this.cdr.detectChanges();
              return;
            }

            this.lugar = data;
            this.address = data;
            this.validAddress = true;
            this.cdr.detectChanges();
          }
        }
      }
    });
    let business = JSON.parse(localStorage.getItem('business') || '{}');
    if (business) {
      this.placeService.getPlacesByCompany(business.id).subscribe((res) => {
        this.placeList = res.data.data;
        if (this.data && this.data?.space) {
          let space = this.placeList.find(value => value.id == this.data?.space.id);
          this.space = space;
          this.activeSites = true;
          this.online = false;
          this.updatePanelRestrictions();
        }
      });
    }
    if (this.data) {
      this.fromPanel = this.data?.fromPanel;
      if (this.fromPanel) {
        this.eventIsPublished = !!this.data?.publish;
        this.eventHasSales = !!this.data?.purchase && this.data.purchase > 0;
        this.eventUsesMap = !!this.data?.use_map;
        this.isSuperAdmin = !!this.data?.isSuperAdmin;
      }
    }
  }

  ngAfterViewInit() {
    if (this.data && this.data.address) {
      this.textLocation = this.data.address;
      this.onSelectTextPlace(this.textLocation);
    }
  }

  onSearchPlaces() {
    if (this.lugar) {
      this.googlePlacesService.searchPlaces(this.lugar).then((results) => {
        this.searchResults = results;
      });
    } else {
      this.searchResults = [];
    }
  }

  onBlurAddress() {
    setTimeout(() => {
      if (typeof this.lugar === 'string' && this.lugar.trim() !== '') {
        this.openInfoCard(
          'Debes seleccionar una dirección de las opciones sugeridas por el buscador.',
        );
        this.lugar = '';
        this.searchResults = [];
        this.address = null;
        this.validAddress = false;
      }
    }, 250);
  }

  onSelectPlace() {
    this.googlePlacesService.selectPlace(this.lugar);
  }

  onSelectTextPlace(text: string) {
    this.googlePlacesService.searchPlaces(text).then((results) => {
      this.autocomplete?.closePanel();
      this.lugar = results[0];
      this.onSelectPlace();
    });
  }

  onToggleSites() {
    if (!this.activeSites) {
      this.space = null;
      // El div#maplock se recrea por el *ngIf, hay que esperar al siguiente ciclo de render
      setTimeout(() => {
        this.googlePlacesService.openMap();
      });
    } else {
      this.lugar = '';
      this.address = null;
      this.validAddress = false;
    }
    this.updatePanelRestrictions();
  }

  displayFn(location: any): string {
    if (location) {
      return location.description ? location.description : location.formatted_address;
    }
    return '';
  }

  save() {
    // Restringir guardado cuando se usa desde el panel y la combinación no es válida
    if (this.fromPanel && this.panelRestrictionBlock) {
      if (this.panelRestrictionMessage) {
        this.openInfoCard(this.panelRestrictionMessage);
      }
      return;
    }

    const object = {
      online: this.online,
      address: this.address,
      activeSites: this.activeSites,
      space: this.space
    }
    if (this.fromPanel) {
      this.dialogRef.close(object);
      return;
    }
    if (this.address) {
      this.saveLocation.emit(this.address);
      if (this.data) {
        this.dialogRef.close(this.address);
      }
    }
    if (this.online) {
      this.saveOnline.emit(this.online);
      if (this.data) {
        this.dialogRef.close(this.address);
      }
    }
  }

  /**
   * Aplica las reglas de negocio cuando el selector se usa desde
   * el panel de detalle del evento (fromPanel = true).
   */
  private updatePanelRestrictions() {
    if (!this.fromPanel) {
      this.panelRestrictionMessage = null;
      this.panelRestrictionBlock = false;
      return;
    }

    this.panelRestrictionMessage = null;
    this.panelRestrictionBlock = false;

    const publishedWithSales = this.eventIsPublished && this.eventHasSales;

    if (!this.isSuperAdmin && publishedWithSales) {
      const selectedSpaceHasMap =
        this.activeSites &&
        this.space &&
        (this.space.has_map && this.space.current_version);

      // Evento sin mapa o con dirección libre: no permitir pasar a un espacio con mapa
      if (!this.eventUsesMap && selectedSpaceHasMap) {
        this.panelRestrictionMessage =
          'Este evento tiene entradas vendidas y no se puede cambiar a un espacio con mapa de butacas.';
        this.panelRestrictionBlock = true;
      }
    }
  }

  openInfoCard(msg: string) {
    this.dialog.open(InfoCardComponent, {
      panelClass: ['info-dialog'],
      data: {
        icon: true,
        text: msg,
        btnCancel: false,
      },
    });
  }

}
